module.exports = __webpack_public_path__ + "img/boxicons.ac68c5be.svg";